import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IcpState } from './icp.state';

export const selectIcpState = createFeatureSelector<IcpState>('icp');

// ICPs list selectors
export const selectIcps = createSelector(
  selectIcpState,
  (state: IcpState) => state.icps.entities
);

export const selectIcpsLoading = createSelector(
  selectIcpState,
  (state: IcpState) => state.icps.loading
);

export const selectIcpsError = createSelector(
  selectIcpState,
  (state: IcpState) => state.icps.error
);

export const selectIcpsPagination = createSelector(
  selectIcpState,
  (state: IcpState) => state.icps.pagination
);

// ICP detail selectors
export const selectIcpDetail = createSelector(
  selectIcpState,
  (state: IcpState) => state.icpDetail.entity
);

export const selectIcpDetailLoading = createSelector(
  selectIcpState,
  (state: IcpState) => state.icpDetail.loading
);

export const selectIcpDetailError = createSelector(
  selectIcpState,
  (state: IcpState) => state.icpDetail.error
);

// Get ICP detail selectors (new naming convention)
export const selectSelectedIcp = createSelector(
  selectIcpState,
  (state: IcpState) => state.icpDetail.entity
);

export const selectGetIcpDetailLoading = createSelector(
  selectIcpState,
  (state: IcpState) => state.icpDetail.loading
);

export const selectGetIcpDetailError = createSelector(
  selectIcpState,
  (state: IcpState) => state.icpDetail.error
);

// Create ICP selectors
export const selectCreateIcpLoading = createSelector(
  selectIcpState,
  (state: IcpState) => state.createIcp.loading
);

export const selectCreateIcpSuccess = createSelector(
  selectIcpState,
  (state: IcpState) => state.createIcp.success
);

export const selectCreateIcpError = createSelector(
  selectIcpState,
  (state: IcpState) => state.createIcp.error
);

// Update ICP selectors
export const selectUpdateIcpLoading = createSelector(
  selectIcpState,
  (state: IcpState) => state.updateIcp.loading
);

export const selectUpdateIcpSuccess = createSelector(
  selectIcpState,
  (state: IcpState) => state.updateIcp.success
);

export const selectUpdateIcpError = createSelector(
  selectIcpState,
  (state: IcpState) => state.updateIcp.error
);

// Delete ICP selectors
export const selectDeleteIcpLoading = createSelector(
  selectIcpState,
  (state: IcpState) => state.deleteIcp.loading
);

export const selectDeleteIcpSuccess = createSelector(
  selectIcpState,
  (state: IcpState) => state.deleteIcp.success
);

export const selectDeleteIcpError = createSelector(
  selectIcpState,
  (state: IcpState) => state.deleteIcp.error
);

// Combined selectors
export const selectDefaultIcp = createSelector(
  selectIcps,
  (icps) => icps.find(icp => icp.is_default)
);

export const selectIcpById = (id: number) => createSelector(
  selectIcps,
  (icps) => icps.find(icp => icp.id === id)
);